import { AppBar, Box, Button, Card, List, ListItem, Tab, Tabs } from '@material-ui/core'
import axios from 'axios'
import PropTypes from "prop-types"
import { useEffect, useState } from 'react'
import { SERVER_URI } from '../utility/config'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}

export const Feedbacks = ({feedBacks, dispatch}) => {
  let userToken = localStorage.getItem("admin_token")
  const [value, setValue] = useState(0)
    

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
/*   if (!userToken) {
    return <div>Not logged in</div>
  } */

  useEffect(() => {
    const fetchFeedbacks = async () => {
      try {
        const feedbacks = await axios.get(`${SERVER_URI}/get_feedbacks/`, { headers: { Authorization: `Token ${userToken}` } })
        dispatch({ type: "SET_FEEDBACKS", data: feedbacks.data })
      } catch (e) {
        console.log("Error in getting feedbacks", e)
      }
    }
    fetchFeedbacks()

    const intervalId = setInterval(() => {
      if (userToken) {
        fetchFeedbacks()
      }
    }, 30000)

    return () => {
      console.log("Clearing interval")
      clearInterval(intervalId)
    }

  }, [dispatch, userToken])

  if (!feedBacks) {
    return <div>Loading</div>
  }

  const unreadFeedbacks = feedBacks.filter(feedback => feedback.isRead === false)
  const readFeedbacks = feedBacks.filter(feedback => feedback.isRead === true)
  if (unreadFeedbacks.length === 0 && readFeedbacks.length === 0) {
    return <Box className='configurations'>
        <h3>Ei palautteita</h3>
        </Box>
  }

  return(<>

    <AppBar position="relative">
			<Tabs value={value} onChange={handleChange} sx={{ minWidth: "100%" }}>
        <Tab label="Lukemattomat" {...a11yProps(0)} />
        <Tab label="Luetut" {...a11yProps(1)} />
			</Tabs>
		</AppBar>
      <Box className='configurations'>
      <h2>Palautteet</h2>
				<TabPanel as={"div"} value={value} index={0}>
          <UnreadFeedbacks feedBacks={unreadFeedbacks} dispatch={dispatch} userToken={userToken} />
        </TabPanel>
        <TabPanel as={"div"} value={value} index={1}>
          <ReadFeedbacks feedBacks={readFeedbacks} dispatch={dispatch} userToken={userToken} />
        </TabPanel>
        </Box>
		
    </>
  )
}

const UnreadFeedbacks = ({feedBacks, dispatch, userToken}) => {
  const markAsRead = async (id) => {
    try {
      await axios.put(`${SERVER_URI}/mark_feedback_as_read/${id}`, null, { headers: { Authorization: `Token ${userToken}` } })
      dispatch({ type: "MARK_FEEDBACK_AS_READ", data: id })
    } catch (e) {
      console.log("Error in marking feedback as read", e)
    }
  }

  if (feedBacks.length === 0) {
    return <Box className='configurations'>
        <h3>Ei uusia palautteita</h3>
        </Box>
  }

  return (<Box className='configurations'>
      <List style={{display: 'flex', flexDirection: 'column', width: '100%', gap: '20px', justifyContent: 'center', justifyItems: 'center', alignItems: 'center'}}>
        {feedBacks.slice().reverse().map((feedback) => (
        <Card style={{width: '80%'}} key={feedback.id}>
          <ListItem style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
              <Box style={{width: '100%', justifyContent: 'center', textAlign: 'center'}}>{feedback.feedback}</Box>
              <Box style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                <Box>{new Date(feedback.timestamp).toLocaleString('fi-FI')}</Box>
                <Box>{feedback.feedbackSource === "driver" ? "Kuljettajan palaute" : feedback.phoneNumber}</Box>
              </Box>
              <Button id="gradient_Button" style={{}} fullWidth onClick={()=>markAsRead(feedback.id)}>Kuittaa</Button>
          </ListItem>
        </Card>
        ))}
      </List>
  </Box>)
}

const ReadFeedbacks = ({feedBacks, dispatch, userToken}) => {

  const deleteFeedback = async (id) => {
    try {
      await axios.delete(`${SERVER_URI}/delete_feedback/${id}`, { headers: { Authorization: `Token ${userToken}` } })
      dispatch({ type: "DELETE_FEEDBACK", data: id })
    } catch (e) {
      console.log("Error in deleting feedback", e)
    }
  }

  if (feedBacks.length === 0) {
    return <Box className='configurations'>
        <h3>Ei luettuja palautteita</h3>
        </Box>
  }

  return (<Box className='configurations'>
      <List style={{display: 'flex', flexDirection: 'column', width: '100%', gap: '20px', justifyContent: 'center', justifyItems: 'center', alignItems: 'center'}}>
        {feedBacks.slice().reverse().map((feedback) => (
        <Card style={{width: '80%'}} key={feedback.id}>
          <ListItem key={feedback.id} style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
              <Box style={{width: '100%', justifyContent: 'center', textAlign: 'center'}}>{feedback.feedback}</Box>
              <Box style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                <Box>{new Date(feedback.timestamp).toLocaleString('fi-FI')}</Box>
                <Box>{feedback.feedbackSource === "driver" ? "Kuljettajan palaute" : feedback.phoneNumber}</Box>
              </Box>
              <Button id="gradient_Button" style={{}} fullWidth onClick={() => deleteFeedback(feedback.id)}>Poista palaute</Button>
          </ListItem>
        </Card>
        ))}
      </List>
  </Box>)
}